import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.user');
import { OnInit, OnChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.user/view.scss */
/* src/app/component.nav.user/view.scss: no such file or directory */`],
})
export class ComponentNavUserComponent implements OnInit, OnChanges {
    constructor(@Inject( Service)         public service: Service) { }

    public userMenu = [
        { id: 'dashboard', label: '대시보드', icon: 'LayoutDashboard', path: '/ui/dashboard', ctf: false },
        { id: 'rawdata', label: '데이터 관리', icon: 'Database', path: '/ui/rawdata', ctf: false, adminOnly: true },
        {
            id: 'dataset',
            label: '데이터셋 구축',
            icon: 'Cloud',
            ctf: true,
            expanded: true,
            children: [
                { id: 'qadataset', label: 'Fine Tuning QA', icon: 'Caret', path: '/ui/qadataset' },
                { id: 'qainstruct', label: 'Instruction Tuning QA', icon: 'Caret', path: '/ui/qainstruct' },
                // { id: 'dataset-cot', label: 'CoT 데이터셋', icon: 'Caret', path: '/ui/dataset/cot' },
                // { id: 'dataset-eval', label: '평가 데이터셋', icon: 'Caret', path: '/ui/dataset/eval' },
            ]
        },
        // {
        //     id: 'service',
        //     label: '서비스 연동',
        //     icon: 'Cloud',
        //     ctf: true,
        //     expanded: true,
        //     children: [
        //         { id: 'service-api', label: 'API 서비스', icon: 'Caret', path: '/ui/service/api' },
        //         { id: 'service-chat', label: '챗봇 서비스', icon: 'Caret', path: '/ui/service/chat' },
        //     ]
        // },
        { id: 'mypage', label: '마이페이지', icon: 'User', path: '/ui/mypage', ctf: false },
        { id: 'adminpage', label: '사용자 관리', icon: 'Settings', path: '/ui/adminpage', ctf: false, adminOnly: true },
    ];

    public session: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();
        this.session = this.service.auth.session;
        await this.service.render();
    }

    public async toggleMenu(item: string) {
        item.expanded = !item.expanded;
        await this.service.render();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    // lucide 이름 → Tabler 아이콘 클래스 매핑
    public getIconClass(iconName: string) {
        const map = {
            Dot: 'fa-solid fa-circle-dot',
            Caret: 'fa-solid fa-caret-right',
            LayoutDashboard: 'fa-solid fa-gauge',
            Building2: 'fa-solid fa-building',
            Database: 'fa-solid fa-database',
            Bell: 'fa-solid fa-bell',
            FileText: 'fa-solid fa-file-lines',
            User: 'fa-solid fa-user',
            Users: 'fa-solid fa-users',
            TicketCheck: 'fa-solid fa-ticket',
            Network: 'fa-solid fa-network-wired',
            Megaphone: 'fa-solid fa-bullhorn',
            Zap: 'fa-solid fa-bolt',
            Cloud: 'fa-solid fa-cloud',
            Activity: 'fa-solid fa-chart-line',
            BookOpen: 'fa-solid fa-book-open',
            Info: 'fa-solid fa-circle-info',
            Ticket: 'fa-solid fa-ticket',
            FolderOpen: 'fa-solid fa-folder-open',
            Settings: 'fa-solid fa-gear',
            LogOut: 'fa-solid fa-right-from-bracket',
            ChevronDown: 'fa-solid fa-chevron-down',
            Circle: 'fa-solid fa-circle'
        };
        return map[iconName] || 'fa-solid fa-circle';
    }
}

export default ComponentNavUserComponent;